import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SystemAdminService, SystemAdminStats } from '../../../services/system-admin/system-admin.service';

@Component({
  selector: 'app-admin-dashboard',
  imports: [CommonModule],
  templateUrl: './dashboard.html',
})
export class AdminDashboard implements OnInit {
  private systemAdminService = inject(SystemAdminService);
  private destroyRef = inject(DestroyRef);

  stats = signal<SystemAdminStats | null>(null);
  loading = signal(true);

  ngOnInit(): void {
    this.loadStats();
  }

  loadStats(): void {
    this.loading.set(true);
    this.systemAdminService.getStats().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (stats) => {
        this.stats.set(stats);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }
}
